import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LocationBeggingModal = _resolveComponent("LocationBeggingModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_view),
    (_ctx.displayLocationPrompt)
      ? (_openBlock(), _createBlock(_component_LocationBeggingModal, {
          key: 0,
          onContinue: _ctx.requestLocationPermission,
          "is-informational": false
        }, null, 8, ["onContinue"]))
      : _createCommentVNode("", true)
  ]))
}